import { createSlice } from "@reduxjs/toolkit";

// Minimal stub — full implementation lives in another sprint/branch.
// This stub exists only so the bundler can resolve the import in store.js
// while that work is in progress.
const slice = createSlice({
  name: "jobs",
  initialState: {
    list: [],
    current: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCurrent: (s) => {
      s.current = null;
    },
  },
});

export const { clearCurrent } = slice.actions;
export default slice.reducer;
